// src/feathers-client.js
import feathers from '@feathersjs/feathers'
// import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
// import io from 'socket.io-client'
import {iff, discard} from 'feathers-hooks-common'
import feathersVuex from 'feathers-vuex'
import rest from '@feathersjs/rest-client'

const serverAddress = process.env.VUE_APP_SERVER_ADDRESS;
// const portalAddress = 'https://evention.loming.com';
const portalAddress = process.env.VUE_APP_PORTAL_ADDRESS;

const restClient = rest(serverAddress);
// const socket = io(serverAddress, {
//     transports: ['websocket'],
//     forceNew: true,
//     timeout: 120000,
// });

const feathersClient = feathers()
    // .configure(socketio(socket, {timeout: 120000, pingTimeout: 120000, upgradeTimeout: 120000}))
    .configure(restClient.fetch(window.fetch.bind(window)))
    .configure(auth({storage: window.localStorage}))
    .hooks({
        before: {
            all: [
                iff(
                    context => ['create', 'update', 'patch'].includes(context.method),
                    discard('__id', '__isTemp')
                )
            ]
        }
    });

export default feathersClient;

// Setting up feathers-vuex
const {makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex} = feathersVuex(
    feathersClient,
    {
        serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
        idField: '_id', // Must match the id field in your database table/collection
        whitelist: ['$regex', '$options'],
        debug: true,
    }
);

export {serverAddress, portalAddress, makeAuthPlugin, makeServicePlugin, BaseModel, models, FeathersVuex}
